import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = (data) => axios.post(`${API}/enquiries`, data);

export const submitCandidate = (formData) =>
  axios.post(`${API}/candidates`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const submitContact = (data) => axios.post(`${API}/contact`, data);
